export default __webpack_public_path__ + "4d8030d3515f893316860e802b839ce8.png";